export default Object.freeze({
  phone: 600,
  tablet: 900,
  desktop: 1200,
});
